module.exports = __webpack_public_path__ + "img/help_grey.6a22c945.png";